import CustomModal from './CustomModal';
export * from './CustomModal';
export default CustomModal;
